import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchMe } from '../api/admin.js'
import { useAuthStore } from '../store/auth.js'

export function useAdminMe() {
  const setUser = useAuthStore((s) => s.setUser)
  const reset = useAuthStore((s) => s.reset)
  const q = useQuery({ queryKey: ['admin-me'], queryFn: fetchMe, retry: false, staleTime: 60_000 })
  useEffect(() => {
    if (q.data?.user) setUser(q.data.user)
    else if (q.isError) reset()
  }, [q.data, q.isError, setUser, reset])
  return q
}
